import * as React from 'react';

export class Login extends React.Component<{}, {}> {
  login = () => {
    // authService.login();
  };

  render() {
    return (
      <div>
        <button onClick={() => ({})}>Login</button>
      </div>
    );
  }
}
